import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
const {fontExtraBold, fontRegular, fontSemiBold} = SkillzStyle.fullStyles;

export const stylesFn = (isDrawerShowing: boolean) =>
  StyleSheet.create({
    footerToastContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      top: isDrawerShowing ? 0 : '100%',
      backgroundColor: isDrawerShowing ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
    },
    headerText: {
      color: '#333',
      ...fontExtraBold,
      fontSize: 16,
      textTransform: 'capitalize',
    },
    headerContainerStyleOverride: {
      paddingTop: 10,
      marginTop: 5,
      height: 60,
    },

    footerContentScrollContainer: {
      marginHorizontal: 12,
      backgroundColor: '#FFF',
      borderTopColor: '#DCDCDC',
      borderTopWidth: 1,
      marginBottom: 80,
    },

    footerContentContainer: {
      height: 300,
    },
    footerInnerContent: {},

    // BankAccount Item Styles
    bankAccountItemContainer: {
      paddingVertical: 16,
      borderBottomWidth: 1,
      borderBottomColor: '#DCDCDC',
      paddingHorizontal: 34,
    },

    bankAccountItemContainerSelected: {
      paddingVertical: 16,
      borderBottomWidth: 1,
      borderBottomColor: '#DCDCDC',
      backgroundColor: 'rgba(54, 123, 206, 0.10)',
      paddingHorizontal: 34,
    },

    bankAccountNameContainer: {
      display: 'flex',
      flexDirection: 'row',
    },

    bankAccountName: {
      fontSize: 13,
      color: '#2D2D2D',
      ...fontSemiBold,
      paddingBottom: 4,
    },
    bankName: {
      fontSize: 13,
      color: '#757575',
      ...fontRegular,
    },

    blueCheckIcon: {
      position: 'absolute',
      left: -22,
      top: 2,
      width: 15,
      height: 15,
    },

    // Link Account Button Styles
    linkAccountButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      marginTop: 10,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#FFF',
      height: 80,
    },
    linkAccountButtonText: {
      fontSize: 16,
      color: '#367BCE',
      ...fontExtraBold,
      textAlign: 'center',
      paddingVertical: 16,
    },
    rightArrowIcon: {
      width: 40,
      height: 40,
      marginLeft: -10,
      marginTop: 2,
    },
  });
